import * as React from 'react';
import { cn } from '../../lib/utils';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'secondary' | 'outline' | 'success' | 'ai' | 'warning';
}

export function Badge({ className, variant = 'default', ...props }: Readonly<BadgeProps>) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors',
        {
          'bg-brand-100 text-brand-700': variant === 'default',
          'bg-slate-100 text-slate-600': variant === 'secondary',
          'border border-slate-200 text-slate-600 bg-white': variant === 'outline',
          'bg-emerald-100 text-emerald-700': variant === 'success',
          'bg-gradient-to-r from-brand-500 to-violet-500 text-white shadow-sm': variant === 'ai',
          'bg-amber-100 text-amber-700': variant === 'warning',
        },
        className
      )}
      {...props}
    />
  );
}
